import Banner from './Banner'
import ChampignonsList from './ChampignonsList'



function App() {

	return (
		<div>
			<Banner />
			<ChampignonsList />
		</div>
	)
}

export default App
